module.exports = __webpack_public_path__ + "static/cranach-hero-272db35a0cb45698303bf5bef5a50061.jpg";